const MauritaniaSvg = () => (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_4152_111861)">
      <path
        d="M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40Z"
        fill="#496E2D"
      />
      <path
        d="M19.9999 23.1066C16.6698 23.1066 13.8878 20.7661 13.2052 17.6407C13.1003 18.1212 13.0435 18.6194 13.0435 19.1314C13.0435 22.9735 16.1579 26.0879 19.9999 26.0879C23.842 26.0879 26.9564 22.9734 26.9564 19.1314C26.9564 18.6194 26.8996 18.1212 26.7947 17.6406C26.1121 20.7662 23.3301 23.1066 19.9999 23.1066Z"
        fill="#FFDA44"
      />
      <path
        d="M19.9997 13.9131L20.6472 15.906H22.7428L21.0475 17.1376L21.695 19.1305L19.9997 17.8988L18.3045 19.1305L18.9521 17.1376L17.2568 15.906H19.3522L19.9997 13.9131Z"
        fill="#FFDA44"
      />
    </g>
    <defs>
      <clipPath id="clip0_4152_111861">
        <rect width="40" height="40" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export default MauritaniaSvg;
